import * as globals from '@wandb/weave/common/css/globals.styles';
import {hexToRGB} from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

// Design-system selection styling: a light-blue fill (BLUE_300) for selected
// rows, slightly stronger when also hovered, and the neutral hover tint for
// unselected rows.
const SELECTED_BG = hexToRGB(globals.BLUE_300, 0.48);
const SELECTED_HOVER_BG = hexToRGB(globals.BLUE_300, 0.64);

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 450px;
`;

export const ProjectSection = styled.div`
  margin: 16px 0;
  width: 215px;
`;

export const ListHeader = styled.div`
  align-self: flex-start;
  padding: 4px 24px;
  text-align: left;
  font-size: 13px;
  color: ${globals.textSecondary};
  white-space: nowrap;
  min-width: 100%;
  box-sizing: border-box;
`;

type ItemProps = {
  selected?: boolean;
};

export const ProjectItem = styled.div<ItemProps>`
  cursor: pointer;
  padding: 4px 24px;
  white-space: nowrap;
  min-width: 100%;
  box-sizing: border-box;
  &.disabled {
    color: ${globals.disabled};
    .icon {
      color: ${globals.disabled};
    }
  }
  &:hover {
    background: ${props => (props.selected ? SELECTED_HOVER_BG : globals.hover)};
  }
  background: ${props => (props.selected ? SELECTED_BG : '')};
`;

export const HorizontalDivider = styled.div`
  border-left: 1px solid #e5e5e5;
  height: auto;
  margin-top: 20px;
`;

export const PanelSection = styled.div`
  margin: 16px 0;
  width: 320px;
`;

export const SearchWrapper = styled.div`
  padding: 4px 18px;
`;

type PanelItemProps = {
  selected?: boolean;
  hover?: boolean;
};

function getBackgroundColor(props: PanelItemProps): string {
  const {selected, hover} = props;
  if (selected && hover) {
    return SELECTED_HOVER_BG;
  }
  if (selected) {
    return SELECTED_BG;
  }
  if (hover) {
    return globals.hover;
  }
  return '';
}

export const PanelItem = styled.li<PanelItemProps>`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 24px;
  // The list can scroll horizontally to reveal full (untruncated) names; each
  // row fills the full scrollable content width (via the list's widened inner
  // element) so the selected/hover highlight spans the whole row with an
  // aligned right edge instead of stopping at the end of the text.
  min-width: 100%;
  box-sizing: border-box;

  &.disabled {
    color: ${globals.disabled};
    .icon {
      color: ${globals.disabled};
    }
  }
  &:hover {
    background: ${props => (props.selected ? SELECTED_HOVER_BG : globals.hover)};
  }
  ${props => css`
    ${
      (props.selected || props.hover) &&
      `background: ${getBackgroundColor(props)};`
    }
  `}
`;

export const TextWrapper = styled.div`
  // Keep the full metric name on a single line; horizontal scrolling of the
  // list (not truncation) is what lets long names be read in full.
  white-space: nowrap;
`;
